import styled from 'styled-components';

export const LiveLegendContainer = styled.div<{ $top: number; $left: number; $isDragging: boolean }>`
  position: absolute;
  top: ${props => props.$top}px;
  left: ${props => props.$left}px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid #0C5C75;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 4px 16px rgba(12, 92, 117, 0.15);
  z-index: 10;
  min-width: 160px;
  backdrop-filter: blur(5px);
  cursor: ${props => props.$isDragging ? 'grabbing' : 'grab'};
  user-select: none;
  transition: ${props => props.$isDragging ? 'none' : 'box-shadow 0.2s ease'};
  
  &:hover {
    box-shadow: 0 6px 20px rgba(12, 92, 117, 0.25);
  }
`;

export const LegendTitle = styled.h4`
  margin: 0 0 10px 0;
  color: #0C5C75;
  font-size: 0.85em;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  text-align: center;
  border-bottom: 1px solid #FFB30D;
  padding-bottom: 6px;
  position: relative;
  
  &::before {
    content: '⋮⋮';
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.8em;
    color: #0C5C75;
    opacity: 0.6;
    letter-spacing: -2px;
  }
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  font-size: 0.75em;
  font-family: 'Montserrat', sans-serif;
`;

export const ColorIndicator = styled.div<{ color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.color};
  margin-right: 6px;
  border: 1px solid white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
`;

export const LegendText = styled.div`
  flex: 1;
`;

export const SensorName = styled.div`
  color: #0C5C75;
  font-weight: 700;
  margin-bottom: 4px;
  font-size: 0.9em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const LastValue = styled.div`
  color: #333;
  font-size: 1.4em;
  font-weight: 600;
  background: rgba(255, 179, 13, 0.1);
  padding: 3px 6px;
  border-radius: 4px;
  border-left: 2px solid #FFB30D;
`;

export const GraphContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;